import React, { useState, memo } from 'react';
import './Option_CM.css';
import _ from 'lodash';
import { DATA_CM } from '../util/util_CM';
import StatusOption_CM from './StatusOption_CM';
import { SubMenu_CM } from './SubMenu_CM';
import { Separator } from '../../form';
import t from '../../../i18n/I18n';
import ActionUtil_CM from '../util/actionUtil_CM';
import { Fragment } from 'react';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import ToolTip from '../../AssetPropertyView';
import RightClickMenuTooltip from '../../../constants/RightClickMenuTooltip';

export type SeperatorByOption = {
  above: boolean,
  below: boolean
};

type Options = {
  ON_Click: Function,
  LABEL: string,
  ARGS: Array<string>,
  PREDICATES: Function
};
type Action =
  | {
    key: String,
    value: Array<string>
  }
  | string;

type Props = {
  action: Action
};

const onClickAction = (e, onClick, args) => {
  onClick(e, args);
  args.closeContextMenu();
};

function Option_CM(props: Props = { actions: [] }) {
  const getOptions = (key, onClick, label, args, icon = '', iconOnHover = '') => {
    const [isHover, setIsHover] = useState(false);
    const onHoverHandler = (event) => {
      setIsHover(true);
    };

    const onMouseLeave = (event) => {
      setIsHover(false);
    };

    const ToolTipLabel = RightClickMenuTooltip[t(label)?.toLowerCase()];

    return (
      <ToolTip text={ToolTipLabel} maxWidth={300} style={{ padding: 0 }}>
        <div
          className="options"
          key={key}
          onClick={(e) => onClickAction(e, onClick, args)}
          onMouseOver={onHoverHandler}
          onMouseLeave={onMouseLeave}>
          <img src={isHover ? ThemeSetup.getImageURL(iconOnHover) : icon} />
          <span>{t(label)}</span>
        </div>
      </ToolTip>
    );
  };

  const getOptionByAction = (index: number, action: Action) => {
    const options: Options = DATA_CM.OPTIONS[action];
    const args = DATA_CM.FUNCTIONS.fileterProps(props, options.ARGS);
    args.action = action;
    const actionUtil_CM_Obj: ActionUtil_CM = ActionUtil_CM.getInstance();
    const seperatorByOption: SeperatorByOption = actionUtil_CM_Obj.getSeparatorByOptionsMap(args).get(action);
    if (options.PREDICATES(args)) {
      if (seperatorByOption) {
        if (seperatorByOption.above)
          return (
            <Fragment key={index}>
              <Separator></Separator>
              {getOptions(index, options.ON_Click, options.LABEL, args, options.ICON, options.ICON_On_Hover)}
            </Fragment>
          );
        if (seperatorByOption.below)
          return (
            <Fragment key={index}>
              {getOptions(index, options.ON_Click, options.LABEL, args, options.ICON, options.ICON_On_Hover)}
              <Separator></Separator>
            </Fragment>
          );
        else {
          return getOptions(index, options.ON_Click, options.LABEL, args, options.ICON, options.ICON_On_Hover);
        }
      } else {
        return getOptions(index, options.ON_Click, options.LABEL, args, options.ICON, options.ICON_On_Hover);
      }
    } else return null;
  };

  const renderOptions = (index: number, action: Action) => {
    if (_.isObject(action)) {
      const menuName = action.key;
      const icons = action.icons;
      const options: Options = DATA_CM.OPTIONS[menuName];
      let args = [];
      if (options && options.ARGS) {
        args = DATA_CM.FUNCTIONS.fileterProps(props, options.ARGS);
        args.action = action;
      }

      let subMenuProps = {
        menuName: menuName,
        key: `submenu${index}-${action}`,
        icon: icons && icons.icon ? icons.icon : null,
        iconOnHover: icons && icons.icon ? icons.iconOnHover : null
      };
      if (action.component) {
        const getSubMenuComponent = () => {
          const SubMenuCompoent = action.component;
          return <SubMenuCompoent {...args} />;
        };
        subMenuProps.isComponent = true;
        subMenuProps.Component = getSubMenuComponent();
      } else {
        const items = action.value.map((subAction, index) => {
          return renderOptions(index, subAction);
        });
        subMenuProps.items = items;
      }

      if (options && options.hasOwnProperty('PREDICATES')) {
        return options.PREDICATES(args) ? <SubMenu_CM {...subMenuProps} /> : null;
      } else {
        return <SubMenu_CM {...subMenuProps} />;
      }
    } else {
      return getOptionByAction(index, action);
    }
  };

  const renderStatusOption = (index, action, args) => {
    const options: Options = DATA_CM.OPTIONS[action];
    return <StatusOption_CM key={index} {...args} />;
  };

  return (
    <div name="options-cm">
      {props.actions.map((action, index) => {
        if (action === 'STATUS') {
          const options: Options = DATA_CM.OPTIONS[action];
          const args = DATA_CM.FUNCTIONS.fileterProps(props, options.ARGS);
          return options.PREDICATES(args) ? renderStatusOption(index, action, args) : null;
        }
        return renderOptions(index, action);
      })}
    </div>
  );
}
export default memo(Option_CM);
